.DialogErrorFallback {
  font-size: 1rem;
}

.DialogActions {
  --dialog-actions-grid: auto / max-content max-content;
  justify-content: end;
}
